import { QueryResult } from 'react-query';
import { callApi, Controller, useApi, UseApiOptions } from './useApi';
// eslint-disable-next-line import/no-cycle
import { ArtikelDetail } from './artikelDetail';
// eslint-disable-next-line import/no-cycle
import { ArtikelDetailLieferant } from './artikelDetailLieferant';

export interface AuftragPosition {
    kNr: number;
    auNr: string;
    artikelGruppeNr: number;
    artikelNr: string;
    pos: number;
    posText: string;
    posEinh: string;
    posMenge: number;
    posEkPreis: number;
    posEPreis: number;
    posNetto: number;
    posMwst: number;
    posBrutto: number;
    posBem: string;
    lArt: string;
    offen: number;

    updDat?: string;
    updUhr?: number;
    updUser?: string;

    transfer?: boolean;
    transferMenge?: number;
    transferBestand?: number;
    transferLArt?: string;

    artikelDetail?: ArtikelDetail;
    hauptlieferant?: ArtikelDetailLieferant;
}

export interface AuftragPositionFilter {
    auNrList?: string[];
    kNr?: number;
    auNr?: string;
    pos?: number;
    artikelGruppeNr?: number;
    artikelNr?: string;

    excludeReclay?: boolean;
    withArtikelDetail?: boolean;
    withHauptlieferant?: boolean;
}

export const defaultAuftragPosition: AuftragPosition = {
    kNr: 0,
    auNr: '',
    artikelGruppeNr: 0,
    artikelNr: '',
    pos: -1, // -1 = new
    posText: '',
    posEinh: '',
    posMenge: 0,
    posEkPreis: 0,
    posEPreis: 0,
    posNetto: 0,
    posMwst: 20,
    posBrutto: 0,
    posBem: '',
    lArt: '',
    offen: 0,
};

export function useAuftragPositionList(
    filter: AuftragPositionFilter,
    apiOptions?: UseApiOptions<AuftragPosition[]>,
): QueryResult<AuftragPosition[]> {
    return useApi<AuftragPosition[]>(Controller.auftragPosition + '/list', { filter }, apiOptions);
}

interface AddAuftragPositionResult {
    newNr: number;
}

export async function addAuftragPosition(auftragPosition: AuftragPosition): Promise<AddAuftragPositionResult> {
    return callApi<AddAuftragPositionResult>(Controller.auftragPosition + '/add', { auftragPosition });
}

export async function updateAuftragPosition(auftragPosition: AuftragPosition): Promise<void> {
    return callApi<void>(Controller.auftragPosition + '/update', { auftragPosition });
}

export async function deleteAuftragPosition(auftragPosition: AuftragPosition): Promise<void> {
    return callApi<void>(Controller.auftragPosition + '/delete', { auftragPosition });
}

export async function moveUpAuftragPosition(auNr: string, pos: number): Promise<void> {
    return callApi<void>(Controller.auftragPosition + '/moveup', {
        auftragPosition: {
            auNr,
            pos,
        },
    });
}

export async function changeAuftragPositionMenge(auftragPosition: AuftragPosition): Promise<void> {
    return callApi<void>(Controller.auftragPosition + '/changeMenge', { auftragPosition });
}
